import { InternalLinkProps } from "../sitemap/plp-sitemap";
import { PlpSubpage } from "../sitemap/use-plp-subpage";
import cn from "classnames";
import { subpageTagOrder } from "./spare-parts-navigation";
import type { TranslatedValue } from "@swo/storefront";

export type Step = {
  key: string;
  label: string | TranslatedValue;
  link: InternalLinkProps | undefined;
  disabled?: boolean;
};
export type StepProps = ReturnType<typeof getStepProps>;

export function getStepProps(steps: Array<Step>, currentSubPageTag: PlpSubpage["tag"], shift: number) {
  const currentIdx = subpageTagOrder.indexOf(currentSubPageTag) - 1;

  const thisIdx = typeof currentIdx === "number" ? currentIdx + shift : undefined;

  const step: Step | undefined = typeof thisIdx === "number" ? steps[thisIdx] : undefined;

  const isPrevious = typeof thisIdx === "number" && typeof currentIdx === "number" ? thisIdx < currentIdx : false;
  const isCurrentlySelected = currentIdx === thisIdx;

  return {
    step,
    thisIdx,
    currentIdx,
    isPrevious,
    isCurrentlySelected,
    className: cn({ active: isCurrentlySelected, checked: isPrevious, disabled: step ? step.disabled : true }),
    text: typeof thisIdx === "number" ? (thisIdx === steps.length - 1 ? "✓️" : (thisIdx + 1).toString()) : "",
  };
}
